/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as Msdyn365 from '@msdyn365-commerce/core';
import { GetWineFilterable } from './get-wine-filterable-class';

/**
 * query filter definition
 */
export interface IGetWineProductQueryFilters {
    brand?: string;
}

/**
 * GetWineProducts Input Action
 */

export class GetWineProductsInput extends GetWineFilterable<IGetWineProductQueryFilters > {

    private readonly _url: string = 'https://api.smwe.com';

    public get url(): string {
        const { brand } = this.queryFilters;

        const fullUrl = `${this._url}/v1/${brand}/products`;
        if (!brand) {
            console.error('Brand Code is not declared. This is required for the module to do calls');
        }
        return fullUrl;
    }
}

export interface IGetWineProductsData {
    product_key: string;
    brand_code: string;
    product_code: string;
    description: string;
}

export interface IGetWineCountriesDataOutput {
    iso: string;
    iso3: string;
    name: string;
    printableName: string;
    numCode: number;
}

const createInput = (args: Msdyn365.ICreateActionContext<IGetWineProductQueryFilters>): Msdyn365.IActionInput => {
    if (!args.config) { throw new Error(`[createWineProductsInput] configuration was invalid: ${args.config}`); }
    return new GetWineProductsInput(args.config);
};

/**
 * action that retrieves the list of wine products
 */
async function action(input: GetWineProductsInput, ctx: Msdyn365.IActionContext): Promise<IGetWineProductsData[]> {
    const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    const response = await Msdyn365.sendRequest<IGetWineProductsData[]>(input.url, 'get', apiSettings, {
        headers: {
            Authorization: `Token token="${input.token}"`
        }
    });
    return response.data;
}

export default Msdyn365.createDataAction({
    action: <Msdyn365.IAction<IGetWineProductsData[]>>action,
    input: createInput
});
